import React, {useState} from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
// import {useTranslation} from "react-i18next";
import LangSwitcher from "../langSwitcher";
import NavIcon from "../_UI/navIcon";
import {cabinetLogout, setMobileNavStatus} from "../../store/cabinet/action";

import log_out_icon from '../../theme/assets/svg/ftf_logout_icon.svg';
import user_icon from '../../theme/assets/other/ftf_user_icon_d.png';
import FtfLogo from "../_UI/ftfLogo";
import {useTranslation} from "react-i18next";


const CabinetNavigation = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    // const userData = useSelector(store => store.main.userData);
    const mobileNavStatus = useSelector(store => store.cabinet.mobileNavStatus);
    const userData = useSelector(store => store.cabinet.userData);

    const [isHover, setIsHover] = useState('');

    const pageHandler = (page) =>{
        const pathname = window.location.pathname;
        return pathname.startsWith(`/${page}`) && (pathname === `/${page}` || pathname.startsWith(`/${page}/`));
    }

    const logoutHandler = () =>{
        dispatch(cabinetLogout());
    }

    return (
        <section className={`${Styles.container} ${mobileNavStatus ? Styles.containerActive : null}`}>
            <div className={`${Styles.userWrap}`}>
                <div className={`${Styles.avatarWrap}`}>
                    <img src={userData?.user?.avatar ? userData?.user?.avatar : user_icon} alt={userData?.user?.username}/>
                </div>
                <div className={`${Styles.nameWrap}`}>
                    <div className={`${Styles.nameTitle}`}>{t('Ваш никнейм')}</div>
                    <div className={`${Styles.name}`}>{userData?.user?.username}</div>
                </div>
                <div className={`${Styles.balanceWrap}`}>
                    <div className={`${Styles.balanceTitle}`}>{t('Ваш баланс токенов')}:</div>
                    <div className={`${Styles.balance}`}>{userData?.user?.coins * 1} <span className={`${Styles.colorRed}`}>FTF</span> = 0 <span className={`${Styles.colorGreen}`}>USDT</span> </div>
                </div>
            </div>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.logoWrap}`} onClick={()=>{navigate('/')}}>
                    <FtfLogo/>
                </div>
                <div className={`${Styles.mainNavWrap}`}>
                    <div
                        className={`${Styles.navItem} ${pageHandler('matrix') ? Styles.navItemActive : null}`}
                        onClick={() => {
                            navigate('/matrix');
                            dispatch(setMobileNavStatus(false));
                        }}
                        onMouseEnter={() => {
                            setIsHover('1')
                        }}
                        onMouseLeave={() => {
                            setIsHover('')
                        }}
                    >
                        <NavIcon type={'1'} isHover={pageHandler('matrix') ? true : isHover === '1'}/>
                        <span>CFP</span>
                    </div>
                    {/*<div*/}
                    {/*    className={`${Styles.navItem} ${window.location.pathname.indexOf('honee-ny') === 1 ? Styles.navItemActive : null}`}*/}
                    {/*    onClick={() => {*/}
                    {/*        navigate('/honee-ny');*/}
                    {/*        dispatch(setMobileNavStatus(false));*/}
                    {/*    }}*/}
                    {/*    onMouseEnter={() => {*/}
                    {/*        setIsHover('18')*/}
                    {/*    }}*/}
                    {/*    onMouseLeave={() => {*/}
                    {/*        setIsHover('')*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <NavIcon type={'18'} isHover={pageHandler('honee-ny') ? true : isHover === '18'}/>*/}
                    {/*    <span>Honee NY</span>*/}
                    {/*</div>*/}
                    <div
                        className={`${Styles.navItem} ${window.location.pathname.indexOf('roadmap') === 1 ? Styles.navItemActive : null}`}
                        onClick={() => {
                            navigate('/roadmap');
                            dispatch(setMobileNavStatus(false));
                        }}
                        onMouseEnter={() => {
                            setIsHover('2')
                        }}
                        onMouseLeave={() => {
                            setIsHover('')
                        }}
                    >
                        <NavIcon type={'2'} isHover={pageHandler('roadmap') ? true : isHover === '2'}/>
                        <span>{t('Дорожная карта')}</span>
                    </div>
                    {/*<div*/}
                    {/*    className={`${Styles.navItem} ${window.location.pathname.indexOf('honee-ny') === 1 ? Styles.navItemActive : null}`}*/}
                    {/*    onClick={() => {*/}
                    {/*        navigate('/honee-ny');*/}
                    {/*        dispatch(setMobileNavStatus(false));*/}
                    {/*    }}*/}
                    {/*    onMouseEnter={() => {*/}
                    {/*        setIsHover('18')*/}
                    {/*    }}*/}
                    {/*    onMouseLeave={() => {*/}
                    {/*        setIsHover('')*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <NavIcon type={'18'} isHover={pageHandler('honee-ny') ? true : isHover === '18'}/>*/}
                    {/*    <span>Honee NY</span>*/}
                    {/*</div>*/}
                    <div
                        className={`${Styles.navItem} ${window.location.pathname.indexOf('leaderboard') === 1 ? Styles.navItemActive : null}`}
                        onClick={() => {
                            navigate('/leaderboard');
                            dispatch(setMobileNavStatus(false));
                        }}
                        onMouseEnter={() => {
                            setIsHover('3')
                        }}
                        onMouseLeave={() => {
                            setIsHover('')
                        }}
                    >
                        <NavIcon type={'3'} isHover={pageHandler('leaderboard') ? true : isHover === '3'}/>
                        <span>{t('Таблица лидеров')}</span>
                    </div>
                    <div
                        className={`${Styles.navItem} ${pageHandler('referral-program') ? Styles.navItemActive : null}`}
                        onClick={() => {
                            navigate('/referral-program');
                            dispatch(setMobileNavStatus(false));
                        }}
                        onMouseEnter={() => {
                            setIsHover('4')
                        }}
                        onMouseLeave={() => {
                            setIsHover('')
                        }}
                    >
                        <NavIcon type={'4'} isHover={pageHandler('referral-program') ? true : isHover === '4'}/>
                        <span>{t('Реферальная программа')}</span>
                    </div>
                    <div
                        className={`${Styles.navItem} ${window.location.pathname.indexOf('contests') === 1 ? Styles.navItemActive : null}`}
                        onClick={() => {
                            navigate('/contests');
                            dispatch(setMobileNavStatus(false));
                        }}
                        onMouseEnter={() => {
                            setIsHover('5')
                        }}
                        onMouseLeave={() => {
                            setIsHover('')
                        }}
                    >
                        <NavIcon type={'5'} isHover={pageHandler('contests') ? true : isHover === '5'}/>
                        <span>{t('Розыгрыши')}</span>
                    </div>
                    <div
                        className={`${Styles.navItem} ${window.location.pathname.indexOf('settings') === 1 ? Styles.navItemActive : null}`}
                        onClick={() => {
                            navigate('/settings');
                            dispatch(setMobileNavStatus(false));
                        }}
                        onMouseEnter={() => {
                            setIsHover('6')
                        }}
                        onMouseLeave={() => {
                            setIsHover('')
                        }}
                    >
                        <NavIcon type={'6'} isHover={pageHandler('settings') ? true : isHover === '6'}/>
                        <span>{t('Настройки')}</span>
                    </div>
                    <div
                        className={`${Styles.navItem} ${window.location.pathname.indexOf('events') === 1 ? Styles.navItemActive : null}`}
                        onClick={() => {
                            navigate('/events');
                            dispatch(setMobileNavStatus(false));
                        }}
                        onMouseEnter={() => {
                            setIsHover('8')
                        }}
                        onMouseLeave={() => {
                            setIsHover('')
                        }}
                    >
                        <NavIcon type={'8'} isHover={pageHandler('events') ? true : isHover === '8'}/>
                        <span>{t('События')}</span>
                    </div>
                    <div
                        className={`${Styles.navItem} ${window.location.pathname.indexOf('transactions') === 1 ? Styles.navItemActive : null}`}
                        onClick={() => {
                            navigate('/transactions');
                            dispatch(setMobileNavStatus(false));
                        }}
                        onMouseEnter={() => {
                            setIsHover('7')
                        }}
                        onMouseLeave={() => {
                            setIsHover('')
                        }}
                    >
                        <NavIcon type={'7'} isHover={pageHandler('transactions') ? true : isHover === '7'}/>
                        <span>{t('Транзакции')}</span>
                    </div>
                </div>
                <LangSwitcher isNotHided={true}/>
                <div className={`${Styles.logOutBtn}`} onClick={()=>{logoutHandler()}}>
                    <img src={log_out_icon} alt="logout"/>
                    <span>{t('Выход')}</span>
                </div>
            </div>
            <div className={`${Styles.logOutBtn}`} onClick={()=>{logoutHandler()}}>
                <img src={log_out_icon} alt="logout"/>
                <span>{t('Выход')}</span>
            </div>
        </section>
    );
};

export default CabinetNavigation;
